import { render } from "./FooterLogo.vue?vue&type=template&id=60927faa"
import script from "./FooterLogo.vue?vue&type=script&lang=js"
export * from "./FooterLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__